export const lightTheme = {
  name: 'light',

  primaryColor: '#7EC8A0',
  primaryDark: '#5AAF80',
  secondaryColor: '#A8DFC0',

  successColor: '#22c55e',
  dangerColor: '#ef4444',
  warningColor: '#f59e0b',
  infoColor: '#7EC8A0',

  bgPrimary: '#ffffff',
  bgSecondary: '#F5FAF7',
  bgTertiary: '#E5F5ED',

  background: '#E5F5ED',
  cardBackground: '#ffffff',
  hoverBackground: '#EFF9F3',

  textPrimary: '#1A3D2B',
  textSecondary: '#2C5F45',
  textMuted: '#4A7A5E',

  borderColor: '#B8E6CD',

  shadow:
    '0 1px 3px 0 rgba(126, 200, 160, 0.18), 0 1px 2px 0 rgba(0, 0, 0, 0.14)',
  shadowLg:
    '0 10px 25px -5px rgba(126, 200, 160, 0.35), 0 8px 10px -6px rgba(0, 0, 0, 0.35)',

  primaryHover: '#6AB88C', // --primary-hover
  primaryStrong: '#3A8F60', // --primary-strong (deep sage, gradient endpoint)
  accentColor: '#5AAF80', // --accent-color
  shadowMd:
    '0 4px 12px -2px rgba(126, 200, 160, 0.22), 0 2px 6px -1px rgba(0, 0, 0, 0.18)', // --shadow-md
  shadowXl:
    '0 20px 50px -10px rgba(126, 200, 160, 0.4), 0 12px 20px -8px rgba(0, 0, 0, 0.4)', // --shadow-xl
  shadowSoft: 'rgba(126, 200, 160, 0.12)', // --shadow-soft

  primaryLight: 'rgba(126, 200, 160, 0.14)',
  unreadBackground: 'rgba(126, 200, 160, 0.06)',
  messageBubbleBg: '#EFF9F3',
  messageReceivedBg: '#ffffff',
  dangerLight: 'rgba(239, 68, 68, 0.1)',
};

export const darkTheme = {
  name: 'dark',

  primaryColor: '#7EC8A0',
  primaryDark: '#5AAF80',
  secondaryColor: '#A8DFC0',

  successColor: '#22c55e',
  dangerColor: '#ef4444',
  warningColor: '#f59e0b',
  infoColor: '#A8DFC0',

  bgPrimary: '#0A1912',
  bgSecondary: '#122A1F',
  bgTertiary: '#1A3D2B',

  background: '#0A1912',
  cardBackground: '#122A1F',
  hoverBackground: '#1A3D2B',

  textPrimary: '#E5F5ED',
  textSecondary: '#B8E6CD',
  textMuted: '#8FCC9F',

  borderColor: '#2C5F45',

  shadow:
    '0 1px 3px 0 rgba(126, 200, 160, 0.4), 0 1px 2px 0 rgba(0, 0, 0, 0.8)',
  shadowLg:
    '0 18px 35px -10px rgba(0, 0, 0, 0.9), 0 0 40px rgba(126, 200, 160, 0.35)',

  primaryHover: '#9ED8B8', // --primary-hover
  primaryStrong: '#5AE898', // --primary-strong (vivid sage-green, gradient endpoint)
  accentColor: '#A8DFC0', // --accent-color
  shadowMd:
    '0 4px 12px -2px rgba(126, 200, 160, 0.3), 0 2px 6px -1px rgba(0, 0, 0, 0.6)', // --shadow-md
  shadowXl:
    '0 28px 60px -14px rgba(0, 0, 0, 0.9), 0 0 60px rgba(126, 200, 160, 0.4)', // --shadow-xl
  shadowSoft: 'rgba(126, 200, 160, 0.2)', // --shadow-soft

  primaryLight: 'rgba(126, 200, 160, 0.3)',
  unreadBackground: 'rgba(126, 200, 160, 0.16)',
  messageBubbleBg: '#1A3D2B',
  messageReceivedBg: '#245138',
  dangerLight: 'rgba(239, 68, 68, 0.25)',
};

export const themes = {
  light: lightTheme,
  dark: darkTheme,
};
